"use client";

import { useEffect } from "react";
import { errorEmitter } from "@/firebase/error-emitter";
import { useToast } from "@/hooks/use-toast";

export default function FirebaseErrorListener() {
  const { toast } = useToast();

  useEffect(() => {
    const handleError = (error: any) => {
      console.error(error);

      // A more specific, developer-friendly error for permission issues
      if (error.name === "FirestorePermissionError") {
         toast({
          variant: "destructive",
          title: "Firestore Security Rules Error",
          description: error.message,
        });
        // Throwing the error so Next.js can handle it in dev overlay
        throw error;
      }

      // Generic error for other Firestore issues
      toast({
        variant: "destructive",
        title: "An Error Occurred",
        description: error.message || "An unknown error occurred.",
      });
    };

    errorEmitter.on("permission-error", handleError);
    errorEmitter.on("error", handleError); // For other generic errors

    return () => {
      errorEmitter.off("permission-error", handleError);
      errorEmitter.off("error", handleError);
    };
  }, [toast]);

  return null;
}
